module.exports = __webpack_public_path__ + "static/media/404.b78a2f81.svg";